import clsx from "clsx";

export function BookingCard({ children, className }: { children?: React.ReactNode; className?: string }) {
  return <div className={clsx("bg-white rounded-lg shadow-md max-w-full px-6 py-4", className)}>{children}</div>;
}
